<template>
	<div>
		<!-- Headline -->
		<div class="flex xs-12 fs5 lh125 fw7 c1 mb2">
			<div class="flex xs-6">{{ showTitle ? $t("beneficiaries") : "" }}</div>
			<div v-if="computedList.length > 0" class="flex xs-6 xs-right x2">
				<j-button v-if="canWrite" class="tertiary" @click="handleAdd">
					<crm-icon name="add" size="normal" color="c2" />
					{{ $t("add_beneficiary") }}
				</j-button>
			</div>
		</div>

		<!-- Items -->
		<j-expendable-box
			v-for="(item, i) in computedList"
			:key="i"
			class="bg5 pl3 fs3 mt2 r2 b1 bc7"
		>
			<div slot="header" class="c2 fw7">
				{{ item.entity.name || "-----" }}
			</div>
			<div slot="body" class="flex wrap xs-12 pb4 pr4 mt4">
				<div class="flex xs-12 mt6">
					<div class="flex xs-6 c6 fw7">{{ $t("ratio") }}</div>
					<div class="flex xs-6 xs-right">
						{{ Number(item.ratio * 100).toFixed(2) }}%
					</div>
				</div>
				<div class="flex xs-12 mt6">
					<div class="flex xs-6 c6 fw7">{{ $t("notes") }}</div>
					<div class="flex xs-6 xs-right">{{ item.notes }}</div>
				</div>
				<div class="flex xs-12 mt6" v-if="item.entity.relationships[0]">
					<div class="flex xs-6 c6 fw7">
						{{ $t("relationship_with_holder") }}
					</div>
					<div class="flex xs-6 xs-right">
						{{ item.entity.relationships[0].type }}
					</div>
				</div>
				<div v-if="canWrite" class="flex xs-12 xs-right mt6 bt1 bc7">
					<j-button
						class="primary mt2"
						size="small"
						@click="handleUpdate(item)"
						>{{ $t("update") }}</j-button
					>
					<j-button
						class="error mt2 ml2"
						size="small"
						@click="handleRemove(item.id)"
						>{{ $t("remove") }}</j-button
					>
				</div>
			</div>
		</j-expendable-box>

		<!-- Empty -->
		<j-card class="bg5" v-if="computedList.length === 0">
			<div class="flex xs-12 xs-center xs-middle p2 ta2 fs3">
				<j-button
					v-if="canWrite"
					class="primary"
					size="xsmall"
					@click="handleAdd"
					>{{ $t("add_beneficiary") }}</j-button
				>
			</div>
		</j-card>

		<!-- Modal -->
		<core-modal name="addUpdateBeneficiary" :headline="headline">
			<add-update-beneficiary
				:type="type"
				v-bind="form"
				@added="afterAdd"
				@updated="afterUpdate"
				@cancelled="$modal.hide('addUpdateBeneficiary')"
			/>
		</core-modal>
	</div>
</template>

<script>
import gql from "@/api/gql.js"
import JCard from "@/components/JCard"
import JExpendableBox from "@/components/JExpendableBox"
import JButton from "@/components/JButton"
import CrmIcon from "@/components/CrmIcon"
import CoreModal from "@/modules/core/components/CoreModal"
import AddUpdateBeneficiary from "./AddUpdateBeneficiary"

export default {
	components: {
		JCard,
		JButton,
		CrmIcon,
		CoreModal,
		AddUpdateBeneficiary,
		JExpendableBox
	},

	data() {
		return {
			headline: "",
			type: "", // add or update payment method
			form: {}
		}
	},

	props: {
		list: { type: Array, required: true, default: () => [] },
		showTitle: {
			type: Boolean,
			required: false,
			default: true
		},
		canWrite: {
			type: Boolean,
			required: false,
			default: true
		}
	},

	computed: {
		computedList() {
			return (this.list || []).map(item => ({
				id: item.id,
				ratio: item.ratio,
				notes: item.notes,
				entity: item.entity
				// {
				//   id
				//   name
				// }
			}))
		}
	},

	methods: {
		handleAdd() {
			this.type = "add"
			this.headline = this.$t("add_beneficiary")
			this.$modal.show("addUpdateBeneficiary")
		},

		handleUpdate(payload) {
			this.type = "update"
			this.form = JSON.parse(JSON.stringify(payload))
			this.headline = this.$t("update_beneficiary")
			this.$modal.show("addUpdateBeneficiary")
		},

		async apiRemoveBeneficiary(variables) {
			const mutation = `
        mutation remove_beneficiary($policyId:String!, $beneficiaryEligibilityId: String!){
          removeBeneficiaryEligibility(policyId:$policyId, beneficiaryEligibilityId: $beneficiaryEligibilityId){
            status
          }
        }
      `
			const res = await gql({
				query: mutation,
				variables
			})
			return Promise.resolve(res)
		},

		async handleRemove(payload) {
			const policyId = this.$route.params.id
			const beneficiaryEligibilityId = payload

			this.isLoading = true

			const res = await this.apiRemoveBeneficiary({
				beneficiaryEligibilityId,
				policyId
			})

			this.isLoading = false

			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
				return
			}

			this.$emit("removed")
		},

		afterAdd() {
			this.$modal.hide("addUpdateBeneficiary")
			this.$emit("added")
		},

		afterUpdate() {
			this.$modal.hide("addUpdateBeneficiary")
			this.$emit("updated")
		}
	}
}
</script>
